// import {KTCard} from '../../../../_metronic/helpers'
// import {Card4} from '../../../../_metronic/partials/content/cards/Card4'
// import {Link} from 'react-router-dom'
// import clsx from 'clsx'
// import React from 'react'

// const features = [
//   {name: 'Mass balance Report', icon: 'waste collector', to: 'mass-balancer-report'},
//   {name: 'Balance', icon: 'payments', to: 'balance'},
//   {name: 'PoS', icon: 'payments', to: 'pos'},
// ]

// const Menu = () => {
//   return (
//     <KTCard addCard={false}>
//       <div className='row g-xl-4'>
//         {features.map((eachFeatures, eachIndex) => (
//           <div key={eachIndex + 1 + ''} className='col col-lg-2'>
//             <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
//               <Card4
//                 // icon={`/media/svg/files/${eachFeatures.icon}.png`}
//                 icon={`/media/svg/files/${eachFeatures.icon}.png`}
//                 title={eachFeatures.name}
//                 description=''
//               />
//             </Link>
//           </div>
//         ))}
//       </div>
//     </KTCard>
//   )
// }

// const MassBalancerMenu = () => <Menu />

// export {MassBalancerMenu}






// import {KTCard} from '../../../../_metronic/helpers'
// import {Card4} from '../../../../_metronic/partials/content/cards/Card4'
// import {Link} from 'react-router-dom'
// import clsx from 'clsx'
// import React from 'react'
// import { useAuth } from '../../auth'
// const Menu = () => {
//   const { currentUser } = useAuth();
//   console.log("cu", currentUser);

//   const features = [
//     {
//       name: 'Mass balance Report',
//       icon: 'waste collector',
//       to: (currentUser as any)?.userType === 'PICKUP_POINT_STAFF'
//         ? 'mass-balancer-report2'
//         : 'mass-balancer-report',
//     },
//     { name: 'Balance', icon: 'payments', to: 'balance' },
//     { name: 'PoS', icon: 'payments', to: 'pos' },
//     { name: 'PoS', icon: 'payments', to: 'pos2' },
//   ];

//   return (
//     <KTCard addCard={false}>
//       <div className='row g-xl-4'>
//         {features.map((eachFeature) => (
//           <div key={eachFeature.to} className='col col-lg-2'>
//             <Link className={clsx('menu-link without-sub')} to={eachFeature.to}>
//               <Card4
//                 icon={`/media/svg/files/${eachFeature.icon}.png`}
//                 title={eachFeature.name}
//                 description=''
//               />
//             </Link>
//           </div>
//         ))}
//       </div>
//     </KTCard>
//   );
// };

// const MassBalancerMenu = () => <Menu />

// export {MassBalancerMenu}
































import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { useAuth } from '../../auth'
const Menu = () => {
  const { currentUser } = useAuth();
  console.log("cu", currentUser);

  const features = [
    {
      name: 'Mass balance Report',
      // icon: 'waste collector',
      icon: 'mb',
      to: (currentUser as any)?.userType === 'PICKUP_POINT_STAFF'
        ? 'mass-balancer-report2'
        : 'mass-balancer-report',
    },
    // { name: 'Balance', icon: 'payments', to: 'balance' },
    // {
    //   name: 'PoS',
    //   icon: 'payments',
    //   to: (currentUser as any)?.userType === 'PICKUP_POINT_STAFF' ? 'pos2' : 'pos'
    // },
  ];

  return (
    <KTCard addCard={false}>
      <div className='row g-xl-4'>
        {features.map((eachFeature) => (
          <div key={eachFeature.to} className='col col-lg-2'>
            <Link className={clsx('menu-link without-sub')} to={eachFeature.to}>
              <Card4
                icon={`/media/svg/files/${eachFeature.icon}.png`}
                title={eachFeature.name}
                description=''
              />
            </Link>
          </div>
        ))}
      </div>
    </KTCard>
  );
};

const MassBalancerMenu = () => <Menu />

export { MassBalancerMenu }
